export { Heart as default } from './Heart';
